import { Row } from '../../interfaces';
import ReuseableTable from '../../components/table/ReuseableTable';
import { headerCells } from '../table/requestsTable';
import { Sort } from '../../types/ui';

type BaseParams = {
  label: string;
  loading: boolean;
  sort?: Sort;
};

// Function to create a tab using the tab name, and the rows to put in that tabs table
export function createTab(
  params:
    | (BaseParams & {
        rows: Row[];
      })
    | (BaseParams & {
        list: any;
      }),
) {
  const { label, loading, sort } = params;
  const emptyMessage = `No ${label} to show right now. If you believe this is an error, please reach out to our support team.`;

  const tab = {
    label,
    component: (
      <>
        {'rows' in params && params.rows && (
          <ReuseableTable
            name={label}
            rows={params.rows}
            headerCells={headerCells}
            emptyMessage={emptyMessage}
            loading={loading}
            sort={sort}
          />
        )}
        {'list' in params && params.list}
      </>
    ),
  };

  return tab;
}
